import React, { useContext, useEffect, useRef, useState } from 'react';
import './DocuMateTodoList.scss';
import { Column, Label, Row, Select } from '../../components';
import DropDownWithLabelInline from '../../shared/components/input/DropDownWithLabelInline';
import './../../index.css';
import Grid from '../../components/components/Grid/Grid';
import * as docuMateConstant from '../shared/util/docuMateConstant';
import * as documateLabel from '../shared/util/docuMateLabel';
import { SelectOption } from '../../shared/components/input';
import DocuMateTodoListService from './DocuMateTodoListService';
import { DocuMateTodoListDto } from '../model/DocuMateTodoListDto';
import { useHistory } from 'react-router-dom';
import { FallbackComponent } from '../../shared/components/FallbackComponent';
import { ErrorBoundary } from 'react-error-boundary';
import { ConfirmModal } from '../../shared/components/confirmModal';
import { FloatLabel } from 'primereact/floatlabel';
import { Alert, Container, Form, Card, Button, FloatingLabel } from 'react-bootstrap';
import Logger from '../../shared/services/Logger';
import { toast } from 'react-toastify';
import * as constant from '../../shared/util/constant';
import { GetDocumentInfoOnSearchResponseDto } from '../model/GetDocumentInfoOnSearchResponseDto';
import { useSelector } from 'react-redux';
import { AbilityContext } from '../../shared/abilities/AbilityContext';
import { useLocation } from 'react-router-dom';
import { CommonUtility } from '../../Services/CommonUtility';
import DocuMateIndexingService from './DocuMateIndexingService';
import { GetFolderListByGroupIdQuery } from '../model/GetFolderListByGroupIdQuery';
import BulkProgressModal from '../shared/components/BulkProgressModal';

export var sampleUserOptions = [];

var sampleGroups = [];
var sampleFolders = [];

interface IToDoListGridState {
    todoList: any[],
    gridColumns: any[],
    groupsList: SelectOption[],
    foldersList: SelectOption[],
    userList: SelectOption[],
    groupId: string,
    folderId: string
}

var sampleGridData: GetDocumentInfoOnSearchResponseDto[] = [];

const initialToDoListGridState: IToDoListGridState = {
    todoList: sampleGridData,
    gridColumns: [],
    groupsList: [],
    foldersList: [],
    userList: [],
    groupId: '',
    folderId: ''
}

export interface DocuMateTodoListprops {
    // onRouteChange?: (route: string) => void;
    isDelete: boolean
}



const DocuMateTodoList: React.FC<DocuMateTodoListprops> = (props) => {

    const todoListService = new DocuMateTodoListService();
    const [todoListGridState, setToDoListGridState] = useState(initialToDoListGridState);
    const {
        todoList,
        gridColumns,
        groupsList,
        foldersList,
        userList,
        groupId,
        folderId } = todoListGridState;
    const [UserSelectDropdown, setUserSelectDropdown] = useState(sampleUserOptions);
    const [UsersSelected, setUsersSelected] = useState([]);
    const [selectedGroupId, setSelectedGroupId] = useState('');
    const [selectedFolderId, setSelectedFolderId] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRowsCount, setSelectedRowsCount] = useState(0);
    const [lockedDocumentIds, setLockedDocumentIds] = useState<string[]>([]);
    const [lockedByMeCount, setLockedByMeCount] = useState(0);
    const lockedCountRef = useRef(0);
    const [showLimitReachedModal, setShowLimitReachedModal] = useState(false);
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const history = useHistory();
    const [docLimitToSelect] = useState(50);
    const [maxDocLockCount] = useState(10);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [currentDocument, setCurrentDocument] = useState<GetDocumentInfoOnSearchResponseDto>(null);
    const [currentDocumentRC, setCurrentDocumentRC] = useState<GetDocumentInfoOnSearchResponseDto>(null);
    const [isUserWorkingOnOtherDoc, setIsUserWorkingOnOtherDoc] = useState(false);
    const [idToRedirect, setIdToRedirect] = useState('');
    const [userDocumentid, setUserDocumentid]= useState('');
    const [documentNameToRedirect, setDocumentNameToRedirect] = useState('');
    const [modalBody, setModalBody] = useState(null);
    const userDetails = useSelector((state: any) => state.userContextSlice);
    const ability = useContext(AbilityContext);
    // Bulk Action permissions
    const canViewBulkAction = !props.isDelete && ability.can('view', docuMateConstant.DocuMateIndexingSubject, docuMateConstant.BulkAction_Field);
    const canReadBulkAction = canViewBulkAction && ability.can('read', docuMateConstant.DocuMateIndexingSubject, docuMateConstant.BulkAction_Field);
    const canUpdateBulkAction = canViewBulkAction && ability.can('update', docuMateConstant.DocuMateIndexingSubject, docuMateConstant.BulkAction_Field);
    const canDeleteBulkAction = canViewBulkAction && ability.can('delete', docuMateConstant.DocuMateIndexingSubject, docuMateConstant.BulkAction_Field);
    const [showBulkDeleteConfirm, setShowBulkDeleteConfirm] = useState(false);
    const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
    const [gridResetKey, setGridResetKey] = useState(0);
    // Bulk Redirect state
    const [showBulkRedirectConfirm, setShowBulkRedirectConfirm] = useState(false);
    const [bulkRedirectLoading, setBulkRedirectLoading] = useState(false);
    const [bulkRedirectGroup, setBulkRedirectGroup] = useState('');
    const [bulkRedirectFolder, setBulkRedirectFolder] = useState('');
    const [bulkRedirectUser, setBulkRedirectUser] = useState('');
    const [bulkRedirectReason, setBulkRedirectReason] = useState('');
    const [bulkRedirectNote, setBulkRedirectNote] = useState('');
    const [bulkRedirectGroupOptions, setBulkRedirectGroupOptions] = useState<any[]>([]);
    const [bulkRedirectFolderOptions, setBulkRedirectFolderOptions] = useState<any[]>([]);
    const [bulkRedirectUserOptions, setBulkRedirectUserOptions] = useState<any[]>([]);
    const [bulkRedirectReasonOptions, setBulkRedirectReasonOptions] = useState<any[]>([]);
    const [bulkRedirectValidation, setBulkRedirectValidation] = useState<any>({});
    const [bulkRedirectNoteRequired, setBulkRedirectNoteRequired] = useState(false);
    const [bulkRedirectProgress, setBulkRedirectProgress] = useState({ current: 0, total: 0, successCount: 0, failureCount: 0, isProcessing: false, isComplete: false });
    // var elementCounter = 4;
    const gridRef = useRef(null);
    const unAssignedDropDownOptionValue = docuMateConstant.TODO_LIST_UsersDropDown_UnAssignedId;
    const location = useLocation();
    const state = location.state as { groupIdFromIndexing: string, folderIdFromIndexing: string };
    const [groupIdFromIndexing, setGroupIdFromIndexing] = useState(state?.groupIdFromIndexing);
    const [folderIdFromIndexing, setFolderIdFromIndexing] = useState(state?.folderIdFromIndexing);

    const FetchGroupDocData = async () => {
        try {
            let data = props.isDelete ? await todoListService.getListOfGroupDocCountRecycleList()
                : await todoListService.getListOfGroupDocCountToDoList();

            if (!props.isDelete && data.length > 0) {
                let filterGroupDataBasedOnRole = [];
                data.forEach(group => {
                    //console.log((userDetails?.userPrivileges?.filter(privilege => (privilege.elementId === group.value && privilege.action === 'view') || (privilege.elementId === group.value && privilege.action === 'read')).length));

                    if (ability.can('view', docuMateConstant.TODO_LIST_GroupSubject, group.label) && ability.can('read', docuMateConstant.TODO_LIST_GroupSubject, group.label))
                    {
                        filterGroupDataBasedOnRole.push(group);
                    }
                });

                data = filterGroupDataBasedOnRole;
            }

            sampleGroups = data;
            setToDoListGridState((prevState) => ({
                ...prevState,
                groupsList: sampleGroups,
            }));

             // set default group from user context based on role
            onGroupSelectChange(userDetails?.userContext?.defaultDocumateGroup);

            if (groupIdFromIndexing !== undefined && groupIdFromIndexing !== '' && sampleGroups.filter(x => x.value === groupIdFromIndexing).length > 0) {
                onGroupSelectChange(groupIdFromIndexing)
            }
        }
        catch (error) {
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    }

    const FetchUsersData = async () => {
        //if isDelete is true then it is for Recycle Bin screen
        if (props.isDelete) {
            try {
                const data = await todoListService.getUsersRecycleBin();
                sampleUserOptions = data;
                setUserSelectDropdown(sampleUserOptions);
                setToDoListGridState((prevState) => ({
                    ...prevState,
                    userList: sampleUserOptions,
                }));
            }
            catch (error) {
                toast.error(constant.ERROR_MESSAGE_LOAD, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
                Logger.logError(error.toString());
            }
        }
    }

    useEffect(() => {
        sampleGroups = [];
        sampleUserOptions = [];
        sampleGridData = [];
        sampleFolders = [];
        FetchGroupDocData();
        FetchUsersData();
        initializeGrid();
    }, []);

    const formatTodoListRowDates = (row) => {
        let dateExpired = '';
        if (row.dateDeleted) {
            let dateDeleted = new Date(row.dateDeleted);
            let formattedExpiredDate = new Date(dateDeleted);
            formattedExpiredDate.setDate(dateDeleted.getDate() + 180);
            dateExpired = CommonUtility.formateDateTime(formattedExpiredDate as any, CommonUtility.DateTimeFormatWithSecond)
        }

        return {
            ...row,
            dateAvailable: CommonUtility.formateDateTime(row.dateAvailable as any, CommonUtility.DateTimeFormatWithSecond),
            dateInitiated: CommonUtility.formateDateTime(row.dateInitiated as any, CommonUtility.DateTimeFormatWithSecond),
            dateDeleted: CommonUtility.formateDateTime(row.dateDeleted as any, CommonUtility.DateTimeFormatWithSecond),
            dateRedirected: CommonUtility.formateDateTime(row.dateRedirected as any, CommonUtility.DateTimeFormatWithSecond),
            dateExpired
        };
    }
    
    const refreshLockedCount = async () => {
        if (props.isDelete) return [];
        try {
            const documentIds = await todoListService.getMyLockedDocuments() ?? [];
            lockedCountRef.current = documentIds.length;
            setLockedByMeCount(documentIds.length);
            setLockedDocumentIds(documentIds);
            return documentIds;
        }
        catch (error) {
            Logger.logError(error.toString());
            return [];
        }
    }

    const initializeGrid = () => {
        refreshLockedCount();
        let columns = props.isDelete ? todoListService.getRecylceBinGridColumns(handleDocumentRecycleBinClick) : todoListService.getTodoListGridColumns(onDeleteDocument, onHardLockDocument, handleOnHoldChange, handleDocumentClick, handleLockToggle);
        setToDoListGridState((prevState) => ({
            ...prevState,
            gridColumns: columns,
            groupsList: sampleGroups,
            foldersList: sampleFolders,
            userList: sampleUserOptions,
            todoList: sampleGridData
        }));
    }

    const onUserSelectChange = (selectedOption) => {
        setUsersSelected(selectedOption);
    };

    const onSelectAllUsers = () => {
        setUsersSelected(UserSelectDropdown);
    };


    const onGroupSelectChange = async (selectedOption) => {
        const groupId = selectedOption ? selectedOption.toString() : '';
        setSelectedGroupId(groupId);

        if (!groupId) {
            setSelectedFolderId('');
            sampleFolders = [];
            sampleUserOptions = [];
            setUsersSelected(sampleUserOptions);
            setUserSelectDropdown(sampleUserOptions);
            setToDoListGridState((prevState) => ({
                ...prevState,
                foldersList: [],
                userList: sampleUserOptions,
            }));
            return;
        }

        const data = props.isDelete
            ? await todoListService.getListOfFolderDocCountRecycleList(groupId)
            : await todoListService.getListOfFolderDocCountToDoList(groupId);

        setSelectedFolderId('');
        sampleFolders = data;
        if (!props.isDelete) {
            let filterFolderDataBasedOnRole = data;
            //check if parked folder is there in folder list and also user have access then keep parked folder else remove parked folder from folder list and then bind to dropdown
            if (data.filter(folder => (folder.value.toUpperCase() === docuMateConstant.Parked_SALES)
                || (folder.value.toUpperCase() === docuMateConstant.Parked_CP)
                || (folder.value.toUpperCase() === docuMateConstant.Parked_CS)).length > 0) {

                // check user have access and if not then remove from folder list
                if (!ability.can('view', docuMateConstant.TODO_LIST_GroupSubject, docuMateConstant.TODO_LIST_FolderParked_Field) || !ability.can('read', docuMateConstant.TODO_LIST_GroupSubject, docuMateConstant.TODO_LIST_FolderParked_Field)) {
                    //remove from folder list
                    filterFolderDataBasedOnRole = data.filter(folder => (folder.value.toUpperCase() !== docuMateConstant.Parked_SALES)
                        && (folder.value.toUpperCase() !== docuMateConstant.Parked_CS)
                        && (folder.value.toUpperCase() !== docuMateConstant.Parked_CP));
                }
                else {
                    filterFolderDataBasedOnRole = data;
                }
            }

            sampleFolders = filterFolderDataBasedOnRole;
        }

        setToDoListGridState((prevState) => ({
            ...prevState,
            foldersList: sampleFolders,
        }));

        if (!props.isDelete) {
            //fetch users based on groupId        
            let groupIdList = [groupId];
            sampleUserOptions = [];
            setUsersSelected(sampleUserOptions);
            setUserSelectDropdown(sampleUserOptions);
            setToDoListGridState((prevState) => ({
                ...prevState,
                userList: sampleUserOptions,
            }));

            const userData = await todoListService.getUsersToDoList(groupIdList);
            sampleUserOptions = userData;
            setUserSelectDropdown(sampleUserOptions);
            setToDoListGridState((prevState) => ({
                ...prevState,
                userList: sampleUserOptions,
            }));
        }

        //if Redirected from Index screen to ToDOList then need to search data based on redirected groupId and folderId
        if (groupIdFromIndexing !== undefined && groupIdFromIndexing !== ''
             && folderIdFromIndexing !== undefined && folderIdFromIndexing !== '' 
             && sampleGroups.filter(x => x.value === groupIdFromIndexing).length > 0
              && sampleFolders.filter(x => x.value === folderIdFromIndexing).length > 0) 
            {
            onFolderSelectChange(folderIdFromIndexing);
            try {
                const lockedByMeDocumentIds = await refreshLockedCount();
                const data = await todoListService.searchDocToDoList([groupIdFromIndexing], [folderIdFromIndexing], null, props.isDelete, lockedByMeDocumentIds);
                sampleGridData = data.map(formatTodoListRowDates);

                setToDoListGridState((prevState) => ({
                    ...prevState,
                    todoList: sampleGridData
                }));
            }
            catch (error) {
                toast.error(constant.ERROR_MESSAGE_LOAD, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
                Logger.logError(error.toString());
            }
        }

        setGroupIdFromIndexing('');
        setFolderIdFromIndexing('');
        window.history.replaceState({}, '');
    };

    const onFolderSelectChange = (selectedOption) => {
        setSelectedFolderId(selectedOption.toString());
    }

    const onDeleteDocument = (id) => {
        setToDoListGridState((prevState) => ({
            ...prevState,
            todoList: prevState.todoList.filter((doc) => doc.id !== id)
        }));
        console.log('onDeleteDocument:' + id);
    }

    const handleClearClick = async () => {
        setSelectedGroupId('');
        setSelectedFolderId('');
        sampleFolders = [];
        sampleUserOptions = [];
        setUsersSelected(sampleUserOptions);
        setUserSelectDropdown(sampleUserOptions);
        sampleGridData = [];
        setToDoListGridState((prevState) => ({
            ...prevState,
            todoList: sampleGridData,
            foldersList: sampleFolders,
            userList: sampleUserOptions,
        }));
    }

    const onHardLockDocument = (id) => {
        setToDoListGridState((prevState) => {
            const updatedTodoList = prevState.todoList.map((doc) =>
                doc.id === id ? { ...doc, canHardLock: false, isHardLocked: true } : doc
            );
            return {
                ...prevState,
                todoList: updatedTodoList
            };
        });
    }

    const handleLockToggle = async (id: string, isCurrentlyLocked: boolean) => {
        if (!id) return;
        const markLock = !isCurrentlyLocked;

        // Check max limit before attempting to lock
        if (markLock && lockedCountRef.current >= maxDocLockCount) {
            setShowLimitReachedModal(true);
            return;
        }
        try {
            // Call backend to lock/unlock document
            const response = await todoListService.toggleDocumentLock(id, markLock );

            if (response?.isUpdated) {
                // Update UI state on success
                setLockedDocumentIds((prevIds) => {
                    if (markLock) {
                        return prevIds.some(docId => docId.toLowerCase() === id.toLowerCase()) ? prevIds : [...prevIds, id];
                    }
                    return prevIds.filter((docId) => docId.toLowerCase() !== id.toLowerCase());
                });

                lockedCountRef.current = markLock ? lockedCountRef.current + 1 : Math.max(0, lockedCountRef.current - 1);
                setLockedByMeCount(lockedCountRef.current);

                setToDoListGridState((prevState) => ({
                    ...prevState,
                    todoList: prevState.todoList.map((doc) =>
                        doc.id === id ? { ...doc, isPickedForLock: markLock, isSoftLock: markLock } : doc
                    )
                }));
            } else {
                // Backend returned false for isUpdated
                toast.warn(docuMateConstant.ALREADY_LOCKED_ERROR, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
            }
        } catch (error) {
            toast.error(`Unable to ${markLock ? 'lock' : 'unlock'} document. Please try again.`, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
        }
    }

    const handleSubmitLockedDocuments = async () => {
        const firstDocumentId = lockedDocumentIds[0];
        if (!firstDocumentId) return;
        setIsSubmitLoading(true);
        try {
            const queueDocs = lockedDocumentIds.map((docId) => ({
                id: docId,
                scanId: todoList.find((doc) => doc.id.toLowerCase() === docId.toLowerCase())?.scanId
            }));

            history.push({
                pathname: `/documate-indexing/processing/${firstDocumentId}`,
                state: {
                    id: firstDocumentId,
                    scanId: queueDocs[0]?.scanId,
                    docStatus: 'working',
                    documentUserId: userDetails?.userContext?.id,
                    queueDocs
                }
            });
        }
        catch (error) {
            toast.error(docuMateConstant.TODO_LIST_AUTOPROCESS_ERROR, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
        finally {
            setIsSubmitLoading(false);
        }
    }

    const handleReleaseAllLocks = async () => { 
        const response = await todoListService.releaseSoftLockDocuments();
        if (response?.isUpdated) {
            // reflect release immediately: clear local lock state and grid highlight
            const remainingLockedDocumentIds = await todoListService.getMyLockedDocuments() ?? [];
            const remainingLockedDocuments = new Set(remainingLockedDocumentIds.map((id) => id?.toString().toLowerCase()));
            setLockedDocumentIds(remainingLockedDocumentIds);
            lockedCountRef.current = remainingLockedDocumentIds.length;;
            setLockedByMeCount(remainingLockedDocumentIds.length);
            setToDoListGridState((prevState) => ({
                ...prevState,
                todoList: prevState.todoList.map((doc) => ({ ...doc, isPickedForLock: remainingLockedDocuments.has(doc.id?.toString().toLowerCase()), isSoftLock: false }))
            }));
            toast.success(docuMateConstant.TODO_RELEASE_SUCCESS, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
        } else {
            toast.error(docuMateConstant.TODO_RELEASE_ERROR, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
        }
    }

    const handleGetSelectedRowsCount = (newCount: number) => {
        setSelectedRowsCount(newCount);
    }

    const getSelectedRows = () => {
        if (gridRef.current) {
            const rows = gridRef.current.getSelectedRows();
            setSelectedRows(rows);
            return rows;
        }
        return [];
    }

    const handleBulkDeleteClick = () => {
        if (selectedRowsCount === 0) return;
        getSelectedRows();
        setShowBulkDeleteConfirm(true);
    }

    const handleBulkDeleteConfirm = async () => {
        setShowBulkDeleteConfirm(false);
        const rows = getSelectedRows();
        if (rows.length === 0) return;
        setBulkDeleteLoading(true);
        try {
            const documentIds = rows.map(row => row.original?.id);
            const indexingService = new DocuMateIndexingService();
            const result = await indexingService.deleteDocument(documentIds);
            if (result != null) {
                toast.success(docuMateConstant.BULK_DELETE_SUCCESS, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
                setSelectedRowsCount(0);
                setBulkDeleteLoading(false);
                if (gridRef.current) gridRef.current.clearSelection();
                await handleSearchClick();
                await refreshFolderCounts();
                return;
            }
        } catch (error) {
            toast.error(docuMateConstant.BULK_DELETE_ERROR, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
        setBulkDeleteLoading(false);
    }

    // Bulk Redirect handlers
    const handleBulkRedirectClick = async () => {
        if (selectedRowsCount === 0) return;
        getSelectedRows();
        if (bulkRedirectGroupOptions.length === 0 || bulkRedirectReasonOptions.length === 0) {
            const indexingService = new DocuMateIndexingService();
            try {
                const [groupData, reasonData] = await Promise.all([
                    indexingService.GetListOfGroup(),
                    indexingService.GetRedirectReason()
                ]);
                setBulkRedirectGroupOptions(groupData);
                setBulkRedirectReasonOptions(reasonData);
            } catch (error) {
                Logger.logError(error.toString());
            }
        }
        setBulkRedirectGroup('');
        setBulkRedirectFolder('');
        setBulkRedirectUser('');
        setBulkRedirectReason('');
        setBulkRedirectNote('');
        setBulkRedirectFolderOptions([]);
        setBulkRedirectUserOptions([]);
        setBulkRedirectValidation({});
        setBulkRedirectNoteRequired(false);
        setShowBulkRedirectConfirm(true);
    }

    const handleBulkRedirectGroupChange = async (selectedOption) => {
        const groupId = selectedOption ? selectedOption.toString() : '';
        setBulkRedirectGroup(groupId);
        setBulkRedirectFolder('');
        setBulkRedirectUser('');
        if (!groupId) {
            setBulkRedirectFolderOptions([]);
            setBulkRedirectUserOptions([]);
            return;
        }
        const indexingService = new DocuMateIndexingService();
        try {
            const getFolderListByGroupIdRequestModel: GetFolderListByGroupIdQuery = {
                GroupId: groupId,
                screenName: "Indexing",
            };
            const [folderData, userData] = await Promise.all([
                indexingService.GetFolderListByGroupId(getFolderListByGroupIdRequestModel),
                indexingService.getUsersToDoList([groupId])
            ]);
            setBulkRedirectFolderOptions(folderData);
            setBulkRedirectUserOptions(userData);
        } catch (error) {
            Logger.logError(error.toString());
        }
    }

    const handleBulkRedirectReasonChange = (selectedOption) => {
        const reason = selectedOption ? selectedOption.toString() : '';
        setBulkRedirectReason(reason);
        setBulkRedirectNoteRequired(
            reason === docuMateConstant.redirectReasonMandatory || reason === docuMateConstant.redirectReasonOther
        );
    }

    const handleBulkRedirectConfirm = async () => {
        const validationErrors: any = {};
        if (!bulkRedirectGroup || bulkRedirectGroup.trim().length === 0) {
            validationErrors['group'] = { isValid: false, warningText: docuMateConstant.INDEXING_UPDATE_MANDATORY };
        }
        if (!bulkRedirectFolder || bulkRedirectFolder.trim().length === 0) {
            validationErrors['folder'] = { isValid: false, warningText: docuMateConstant.INDEXING_UPDATE_MANDATORY };
        }
        if (!bulkRedirectReason || bulkRedirectReason.trim().length === 0) {
            validationErrors['reason'] = { isValid: false, warningText: docuMateConstant.INDEXING_UPDATE_MANDATORY };
        }
        if (bulkRedirectNoteRequired && (!bulkRedirectNote || bulkRedirectNote.trim().length === 0)) {
            validationErrors['note'] = { isValid: false, warningText: docuMateConstant.INDEXING_UPDATE_MANDATORY };
        }
        setBulkRedirectValidation(validationErrors);
        if (Object.keys(validationErrors).length > 0) return;

        const rows = getSelectedRows();
        if (rows.length === 0) return;
        setShowBulkRedirectConfirm(false);
        setBulkRedirectLoading(true);
        setBulkRedirectProgress({ current: 0, total: rows.length, successCount: 0, failureCount: 0, isProcessing: true, isComplete: false });

        const indexingService = new DocuMateIndexingService();
        let successCount = 0;
        let failureCount = 0;

        for (let i = 0; i < rows.length; i++) {
            try {
                const redirectCommand = {
                    QueuedDocId: rows[i].original?.id,
                    GroupId: bulkRedirectGroup,
                    FolderId: bulkRedirectFolder,
                    UserId: bulkRedirectUser ? bulkRedirectUser : null,
                    RedirectReason: bulkRedirectReason,
                    RedirectNote: bulkRedirectNote || ""
                };
                const result = await indexingService.UpdateRedirectData(redirectCommand);
                if (result?.isUpdated) {
                    successCount++;
                } else {
                    failureCount++;
                }
            } catch (error) {
                failureCount++;
            }
            setBulkRedirectProgress({ current: i + 1, total: rows.length, successCount, failureCount, isProcessing: true, isComplete: false });
        }

        setBulkRedirectProgress({ current: rows.length, total: rows.length, successCount, failureCount, isProcessing: false, isComplete: true });
        setBulkRedirectLoading(false);
    }

    const handleBulkRedirectComplete = async () => {
        setBulkRedirectProgress({ current: 0, total: 0, successCount: 0, failureCount: 0, isProcessing: false, isComplete: false });
        setSelectedRowsCount(0);
        if (gridRef.current) gridRef.current.clearSelection();
        await handleSearchClick();
        await refreshFolderCounts();
    }

    const refreshFolderCounts = async () => {
        if (!selectedGroupId) return;
        try {
            const folderData = await todoListService.getListOfFolderDocCountToDoList(selectedGroupId);
            sampleFolders = folderData;
            setToDoListGridState(prev => ({ ...prev, foldersList: sampleFolders }));
        } catch (error) {
            Logger.logError(error.toString());
        }
    }

    const handleOnHoldChange = (id) => {
        setToDoListGridState((prevState) => {
            const updatedTodoList = prevState.todoList.map((doc) =>
                doc.id === id ? { ...doc, onHold: !doc.onHold } : doc
            );
            return {
                ...prevState,
                todoList: updatedTodoList
            };
        });
    }

      const handleDocumentRecycleBinClick = async (id) => {         
            let document = sampleGridData.find(doc => doc.id === id);
            if (document) {
                setCurrentDocumentRC(document);
                 history.push({
                                pathname: `documate-recycle-bin/processing/${id}`,
                                state: { id: id, scanId: document.scanId }
                       });
            }
      }

    const handleDocumentClick = async (id) => {

        let document = sampleGridData.find(doc => doc.id === id);
        if (document) {
            setCurrentDocument(document);
            if (document.isWorking) {
                // checking document is being used by current user or different user.
                // If current user then redirect to indexing page otherwise show modal popup for confirmation to redirect
                if (document.documentUserId === userDetails?.userContext?.id) {
                    history.push({
                        pathname: `documate-indexing/processing/${id}`,
                        state: { id: id, scanId: document.scanId, docStatus: '', documentUserId: document.documentUserId }
                    });
                }
                else if (document.isSoftLock) {
                    setModalBody(getConfirmModalBody(docuMateConstant.SOFT_LOCKED, document.assignedTo, false));
                    setShowConfirmModal(true);
                }
                else {
                    setModalBody(getConfirmModalBody(docuMateConstant.INDEXED, document.assignedTo, false));
                    setShowConfirmModal(true);
                }
            }
            else if (document.isHardLocked) {
                setModalBody(getConfirmModalBody(docuMateConstant.HARD_LOCKED, document.assignedTo, false));
                setShowConfirmModal(true);
            }
            else if (document.canHardLock) {
                setModalBody(getConfirmModalBody(docuMateConstant.SOFT_LOCKED, document.assignedTo, false));
                setShowConfirmModal(true);
            }
            else {
                // when user starts working on document on click of document
                try {
                    const updateDocumentStatus = await todoListService.updateDocStatusToDoList(id, docuMateConstant.IsWorkingDocumentStatus, userDetails?.userContext?.id);
                    if (updateDocumentStatus != null) {
                        setIsUserWorkingOnOtherDoc(updateDocumentStatus.isUserWorkingOnOtherDoc);
                        // if user is not working on other document
                        if (!updateDocumentStatus.isUserWorkingOnOtherDoc) {
                            setToDoListGridState((prevState) => {

                                const updatedTodoList = prevState.todoList.map((doc) =>
                                    doc.id === id ? { ...doc, isWorking: true, documentUserId: updateDocumentStatus.documentUserId, assignedTo: updateDocumentStatus.documentUserName } : doc
                                );

                                sampleGridData = updatedTodoList;
                                return {
                                    ...prevState,
                                    todoList: updatedTodoList
                                };
                            });
                        }

                        //checking document status updated and same user working on document then redirect to indexing screen
                        // else show the popup
                        if (updateDocumentStatus.isUpdated || document.documentUserId === userDetails?.userContext?.id) {
                            history.push({
                                pathname: `documate-indexing/processing/${id}`,
                                state: { id: id, scanId: document.scanId, docStatus: '', documentUserId: document.documentUserId }
                            });
                        }
                        else if (updateDocumentStatus.isUserWorkingOnOtherDoc) {
                            setIdToRedirect(updateDocumentStatus.id);
                            setDocumentNameToRedirect(updateDocumentStatus.fileName);
                            setUserDocumentid(updateDocumentStatus.documentUserId);
                            setModalBody(getConfirmModalBody('', updateDocumentStatus.fileName, true));
                            setShowConfirmModal(true);
                        }
                        else {
                            setModalBody(getConfirmModalBody(docuMateConstant.INDEXED, updateDocumentStatus.documentUserName, false));
                            setShowConfirmModal(true);
                        }
                    }
                }
                catch (error) {
                    toast.error(constant.ERROR_MESSAGE_LOAD, {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: constant.AUTO_CLOSE
                    });
                    Logger.logError(error.toString());
                }
            }
        }
    }

    const handleClosePopup = () => {
        //In case of indexing multiple documents popup close, if 'No' selected then warning needs to show to user.
        if (isUserWorkingOnOtherDoc) {
            toast.warn(docuMateConstant.TODO_LIST_INDEXONLY1DOC_MSG, { position: toast.POSITION.TOP_RIGHT });
        }

        setShowConfirmModal(false);
        setIsUserWorkingOnOtherDoc(false);
        setIdToRedirect('');
        setDocumentNameToRedirect('');
    }

    const handleConfirmModal = () => {
        //In case of indexing single document, redirect to indexing screen with currentDocument details.
        if (!isUserWorkingOnOtherDoc) {
            if (currentDocument) {
                history.push({
                    pathname: `documate-indexing/processing/${currentDocument.id}`,
                    state: { id: currentDocument.id, scanId: currentDocument.scanId, docStatus: currentDocument.isWorking ? 'working' : currentDocument.isHardLocked ? 'hardLocked' : currentDocument.canHardLock ? 'softLocked' : '',
                              documentUserId: currentDocument.documentUserId
                     }
                });
            }
        }
        else {
            //In case of indexing multiple documents (which is not allowed), redirect to indexing screen with already working document details.
            if (idToRedirect !== '' && documentNameToRedirect !== '') {                
                history.push({
                    pathname: `documate-indexing/processing/${idToRedirect}`,
                    state: { id: idToRedirect, scanId: documentNameToRedirect, docStatus: 'working', documentUserId: userDocumentid }
                });
            }
        }

        setShowConfirmModal(false);
    }

    const getConfirmModalBody = (lockType, userName, IsUserWorkingOnOtherDoc) => {
        if (!IsUserWorkingOnOtherDoc) {
            return (
                <>
                    The Image is <strong>{lockType}</strong> by user <strong>{userName}</strong>.
                    <br /> <br /> Would you like to open as <strong>VIEW ONLY</strong>?
                </>
            );
        }
        else {
            return (
                <>
                    You are currently indexing <strong>{userName}</strong>. You must complete current indexing before opening another file.
                    <br /> <br /> Would you like to finish indexing current document?
                </>
            );
        }
    }

    useEffect(() => {
        if (selectedGroupId != "" || selectedFolderId != "") {
            const handleKeyDown = (event: KeyboardEvent) => {
                if (event.key === 'Enter') {
                    handleSearchClick();
                }
            };
            document.addEventListener('keydown', handleKeyDown);
            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [selectedGroupId, selectedFolderId]);

    const handleSearchClick = async () => {
        try {
            const lockedByMeDocumentIds = await refreshLockedCount();
            sampleGridData = [];
            setToDoListGridState((prevState) => ({
                ...prevState,
                todoList: []
            }));

            const todoListService = new DocuMateTodoListService();
            let selectedUserIds = [];
            UsersSelected.forEach(item => {
                selectedUserIds.push(item.value.toString());
            }
            );

            let folderList = [];
            if (selectedFolderId === null || selectedFolderId === '' || selectedFolderId === 'undefined') {
                sampleFolders.forEach(item => {
                    folderList.push(item.value.toString());
                });
            }
            else {
                folderList.push(selectedFolderId);
            }

            let groupId = selectedGroupId === '' ? null : selectedGroupId;
            let folderIds = folderList.length < 1 ? null : folderList;
            if (sampleGroups.length > 0) {
                let groupListArr = [];
                if (groupId === null) {
                    sampleGroups.forEach(item => {
                        groupListArr.push(item.value);
                    });
                }
                else {
                    groupListArr.push(groupId);
                }

                const data = await todoListService.searchDocToDoList(groupListArr, folderIds, selectedUserIds, props.isDelete, lockedByMeDocumentIds);
             
                sampleGridData = data.map(formatTodoListRowDates);

            setToDoListGridState((prevState) => ({
                ...prevState,
                todoList: sampleGridData
            }));
        }
       }
        catch (error) {
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    }


    return (
        <>
            <ErrorBoundary FallbackComponent={FallbackComponent}>
                <Container fluid>
                    <div className='documate-todoList-main-div'>
                        <Row>
                            <Column lg={3} md={2}>
                                <Select
                                    id='todoListGroups'
                                    label={documateLabel.TODO_LIST_GROUPS}
                                    className='mb-3'
                                    controlId='todoListGroups'
                                    options={sampleGroups}
                                    onChange={
                                        (value) => onGroupSelectChange(value)
                                    }
                                    defaultSelected={sampleGroups?.filter(({ value }) => value === selectedGroupId)}
                                    placeholder='Choose Group...'
                                    tabIndex={1}
                                />
                            </Column>
                            <Column lg={3} md={3}>
                                <Select
                                    id='todoListFolders'
                                    controlId='todoListFolders'
                                    className='mb-3'
                                    label={documateLabel.TODO_LIST_FOLDERS}
                                    floatingLabelClass='inlineLable entry-form-inlineLable tsk-grd-first-filter-lable'

                                    options={sampleFolders}
                                    defaultSelected={sampleFolders?.filter(({ value }) => value === selectedFolderId)}
                                    onChange={
                                        (value) => onFolderSelectChange(value)
                                    }

                                    placeholder='Choose ToDo Folder...'
                                    tabIndex={1}
                                />

                            </Column>
                            <Column lg={2} md={2}>
                                <Select
                                    id={'userSelectDropdown'}
                                    tabIndex={1}
                                    className='mb-3'
                                    //  className='userDropDownStyle'
                                    label={props.isDelete ? documateLabel.TODO_LIST_DELETED_BY : documateLabel.TODO_LIST_USERS}
                                    options={UserSelectDropdown}
                                    placeholder={docuMateConstant.PLEASE_SELECT}
                                    sortOptions={false}
                                    inputProps={{
                                        multiple: true,
                                        className: '',
                                        title: (UserSelectDropdown
                                            .filter((option) => UsersSelected.map((option) => option.value).includes(option.value)) // Filter the selected options
                                            .map((option) => option.label) // Extract the label (name) of each user
                                            .toString() // Convert the array of labels to a string
                                            .replaceAll(',', '\r\n')
                                        )
                                    }}
                                    onChange={(values) => {
                                        if (values.includes('allUsers')) {
                                            // If "Select All" is selected, select all options except the "Select All" itself
                                            // const allUsers = UserSelectDropdown.filter(option => option.value !== 'selectAll').map(option => option.value);

                                            setUsersSelected(UserSelectDropdown.filter(option => (option.value !== 'allUsers' && option.value !== unAssignedDropDownOptionValue)));
                                            onUserSelectChange(UserSelectDropdown.filter(option => (option.value !== 'allUsers' && option.value !== unAssignedDropDownOptionValue)));
                                        } else {
                                            // Handle normal selection
                                            const selectedOption = UserSelectDropdown.filter((option) =>
                                                values.includes(option.value)
                                            );
                                            setUsersSelected(selectedOption);
                                            onUserSelectChange(selectedOption);
                                        }
                                    }}
                                    defaultSelected={UsersSelected.map(({ label, value, isInactive }) => ({
                                        label,
                                        value,
                                        isInactive
                                    }))}
                                    multiple={true}

                                />
                            </Column>
                            <Column lg={1} md={1}>
                                <Button variant="primary" key="filter"
                                    onClick={handleSearchClick}
                                    tabIndex={21}
                                    id="searchTodoList"
                                    disabled={false}>Search</Button>
                            </Column>
                            <Column lg={1} md={1}>
                                <Button variant="primary" key="filter"
                                    onClick={handleClearClick}
                                    tabIndex={22}
                                    id="clearTodoList"
                                    className="ClearBtnCss"
                                    disabled={false}>Clear</Button>
                            </Column>
                        </Row>
                        <Alert variant="info" className="p-2 mt-2">
                            Total Image Count: {todoList.length}
                        </Alert>
                        {canViewBulkAction && (
                            <div className="d-flex align-items-center gap-2 mb-2">
                                {selectedRowsCount > 0 && (
                                    <span className="fw-bold">{selectedRowsCount} item(s) selected</span>
                                )}
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    disabled={!canDeleteBulkAction || selectedRowsCount === 0 || bulkDeleteLoading}
                                    onClick={handleBulkDeleteClick}
                                >
                                    Delete Selected
                                </Button>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    disabled={!canUpdateBulkAction || selectedRowsCount === 0 || bulkRedirectLoading}
                                    onClick={handleBulkRedirectClick}
                                >
                                    Redirect Selected
                                </Button>
                                <span className="fw-bold">{lockedByMeCount} of {maxDocLockCount} images locked by you</span>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    disabled={lockedDocumentIds.length === 0 || isSubmitLoading}
                                    onClick={handleSubmitLockedDocuments}
                                >
                                    Start Autoprocessing
                                </Button>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    disabled={lockedDocumentIds.length === 0 || isSubmitLoading}
                                    onClick={handleReleaseAllLocks}
                                >
                                    Release All Locks
                                </Button>
                            </div>
                        )}
                        <div className="">
                            <Card className='p-0'>
                                <Grid
                                    key={`${canViewBulkAction ? 'grid-with-selection' : 'grid-without-selection'}-${gridResetKey}`}
                                    ref={gridRef}
                                    data={todoList}
                                    showFilters={true}
                                    id={'documateToDoListGrid'}
                                    retainGridState={true}
                                    columns={gridColumns}
                                    hiddenColumns={canViewBulkAction ? ['expanded'] : ['selection']}
                                    sortDefault={[]}
                                    grdTableContainerClass="p-0 table-container-campaign"
                                    grdTabelClass="grd-table table-striped table-hover table-sm"
                                    zindexHeader={10000}
                                    onSelectionChange={handleGetSelectedRowsCount}
                                    disableSelection={!canReadBulkAction}
                                    maxSelectionCount={docLimitToSelect}
                                    onMaxSelectionReached={() => {
                                        toast.warn(`You can select a maximum of ${docLimitToSelect} documents at a time.`, {
                                            position: toast.POSITION.TOP_RIGHT,
                                            autoClose: constant.AUTO_CLOSE
                                        });
                                    }}
                                    isRowSelectable={(row) => !row.isSoftLock && !row.isHardLocked && !row.canHardLock && !row.onHold}
                                />
                            </Card>

                            <ConfirmModal
                                modaltitle={documateLabel.CONFIRM}
                                showConfirmation={showConfirmModal}
                                setConfirmation={(isModalOpen) => setShowConfirmModal(isModalOpen)}
                                body={modalBody}
                                closeButtonClick={() => handleClosePopup()}
                                successButtonClick={() => handleConfirmModal()}
                                closeButtonLabel={documateLabel.CONFIRM_NO.toUpperCase()}
                                successButtonLabel={documateLabel.CONFIRM_YES.toUpperCase()}
                            />
                            <ConfirmModal
                                modaltitle={docuMateConstant.BULK_DELETE_CONFIRM_TITLE}
                                showConfirmation={showBulkDeleteConfirm}
                                setConfirmation={(isModalOpen) => setShowBulkDeleteConfirm(isModalOpen)}
                                body={
                                    <>
                                        <p>Are you sure you want to delete {selectedRowsCount} items? This action cannot be undone.</p>
                                        <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '4px', padding: '8px', marginTop: '8px' }}>
                                            {selectedRows.map((row, index) => (
                                                <div key={index} style={{ padding: '4px 0', borderBottom: index < selectedRows.length - 1 ? '1px solid #eee' : 'none' }}>
                                                    {row.original?.scanId}
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                }
                                closeButtonClick={() => setShowBulkDeleteConfirm(false)}
                                successButtonClick={() => handleBulkDeleteConfirm()}
                                closeButtonLabel={documateLabel.CONFIRM_NO.toUpperCase()}
                                successButtonLabel={documateLabel.CONFIRM_YES.toUpperCase()}
                            />
                            <ConfirmModal
                                modaltitle={docuMateConstant.BULK_REDIRECT_CONFIRM_TITLE}
                                showConfirmation={showBulkRedirectConfirm}
                                setConfirmation={(isModalOpen) => setShowBulkRedirectConfirm(isModalOpen)}
                                body={
                                    <>
                                        <p>Are you sure you want to redirect {selectedRowsCount} items?</p>
                                        <div className="mb-2">
                                            <Select
                                                id="bulkRedirectGroup"
                                                controlId="bulkRedirectGroup"
                                                className="mb-2"
                                                label={documateLabel.INDEXING_IMAGING_TASK_LABELS.redirect_to_group}
                                                options={bulkRedirectGroupOptions}
                                                defaultSelected={bulkRedirectGroupOptions?.filter(({ value }) => value === bulkRedirectGroup)}
                                                onChange={(value) => handleBulkRedirectGroupChange(value)}
                                                placeholder="Choose Group..."
                                                isRequired={true}
                                                isInvalid={bulkRedirectValidation.group?.isValid === false}
                                                invalidWarning={bulkRedirectValidation.group?.warningText}
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <Select
                                                id="bulkRedirectFolder"
                                                controlId="bulkRedirectFolder"
                                                className="mb-2"
                                                label={documateLabel.INDEXING_IMAGING_TASK_LABELS.folder}
                                                options={bulkRedirectFolderOptions}
                                                defaultSelected={bulkRedirectFolderOptions?.filter(({ value }) => value === bulkRedirectFolder)}
                                                onChange={(value) => setBulkRedirectFolder(value ? value.toString() : '')}
                                                placeholder="Choose Folder..."
                                                isRequired={true}
                                                isInvalid={bulkRedirectValidation.folder?.isValid === false}
                                                invalidWarning={bulkRedirectValidation.folder?.warningText}
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <Select
                                                id="bulkRedirectUser"
                                                controlId="bulkRedirectUser"
                                                className="mb-2"
                                                label={documateLabel.INDEXING_IMAGING_TASK_LABELS.person}
                                                options={bulkRedirectUserOptions}
                                                defaultSelected={bulkRedirectUserOptions?.filter(({ value }) => value === bulkRedirectUser)}
                                                onChange={(value) => setBulkRedirectUser(value ? value.toString() : '')}
                                                placeholder="Choose Person..."
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <Select
                                                id="bulkRedirectReason"
                                                controlId="bulkRedirectReason"
                                                className="mb-2"
                                                label={documateLabel.INDEXING_IMAGING_TASK_LABELS.redirect_reason}
                                                options={bulkRedirectReasonOptions}
                                                defaultSelected={bulkRedirectReasonOptions?.filter(({ value }) => value === bulkRedirectReason)}
                                                onChange={(value) => handleBulkRedirectReasonChange(value)}
                                                placeholder="Choose Reason..."
                                                isRequired={true}
                                                isInvalid={bulkRedirectValidation.reason?.isValid === false}
                                                invalidWarning={bulkRedirectValidation.reason?.warningText}
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <FloatingLabel controlId="bulkRedirectNote" label={<>{"Redirect Note"}{bulkRedirectNoteRequired && <span className="text-danger ms-1">*</span>}</>} className="mb-2">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Redirect Note"
                                                    value={bulkRedirectNote}
                                                    onChange={(e) => setBulkRedirectNote(e.target.value)}
                                                    maxLength={250}
                                                    isInvalid={bulkRedirectValidation.note?.isValid === false}
                                                />
                                                {bulkRedirectValidation.note?.isValid === false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {bulkRedirectValidation.note?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </div>
                                        <div style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '4px', padding: '8px', marginTop: '8px' }}>
                                            {selectedRows.map((row, index) => (
                                                <div key={index} style={{ padding: '4px 0', borderBottom: index < selectedRows.length - 1 ? '1px solid #eee' : 'none' }}>
                                                    {row.original?.scanId}
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                }
                                closeButtonClick={() => setShowBulkRedirectConfirm(false)}
                                successButtonClick={() => handleBulkRedirectConfirm()}
                                closeButtonLabel={documateLabel.CONFIRM_NO.toUpperCase()}
                                successButtonLabel={documateLabel.CONFIRM_YES.toUpperCase()}
                            />
                            <BulkProgressModal
                                show={bulkRedirectProgress.isProcessing || bulkRedirectProgress.isComplete}
                                title={docuMateConstant.BULK_REDIRECT_CONFIRM_TITLE}
                                current={bulkRedirectProgress.current}
                                total={bulkRedirectProgress.total}
                                successCount={bulkRedirectProgress.successCount}
                                failureCount={bulkRedirectProgress.failureCount}
                                isProcessing={bulkRedirectProgress.isProcessing}
                                isComplete={bulkRedirectProgress.isComplete}
                                onComplete={handleBulkRedirectComplete}
                            />
                            <ConfirmModal
                                modaltitle={documateLabel.CONFIRM}
                                showConfirmation={showLimitReachedModal}
                                setConfirmation={setShowLimitReachedModal}
                                body={
                                    <>
                                        You have reached the <strong> maximum number of documents</strong> to be indexed.
                                    </>
                                }
                                closeButtonClick={() => setShowLimitReachedModal(false)}
                                successButtonClick={() => setShowLimitReachedModal(false)}
                                closeButtonLabel=""
                                successButtonLabel={documateLabel.CONFIRM_OK}
                                okOnly={true}
                            />
                        </div>
                    </div>
                </Container>

            </ErrorBoundary>
        </>
    );
};

export default DocuMateTodoList;